<template>
  <div>
    <div class="top d-flex align-items-center">
      <div class="pic hw70"></div>
      <div class="details">
        <p class="name">
          <span class="fw700">My Name</span>
          <font-awesome-icon size="1x" class="mx-1" :icon="['fal', 'star']" />
          has been reviewed
        </p>
        <p class="time"></p>
      </div>
      <div class="viewRevs font14 fw700 ml-auto" :style="{ color: getPrimaryColor() }">View all reviews</div>
    </div>
    <div class="separator"></div>
    <div class="mid"></div>
    <div class="bottom"></div>
  </div>
</template>

<script>
export default {
  name: "SReview",
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/home/search/SReview.vue